import { allowedFileTypes } from '@porsche-code/kado-file-upload';
import {
  PIcon,
  PIconProps,
  PSpinner,
} from '@porsche-design-system/components-react';

import pdfIcon from '../../icons/file-pdf.svg';

const mapTypeToIconProps = (type: string): PIconProps => {
  return (
    [
      {
        pattern: /image\/.+/,
        props: { name: 'image' as const },
      },
      {
        pattern: /video\/.+/,
        props: { name: 'video' as const },
      },
      {
        pattern: /text\/csv/,
        props: { name: 'file-csv' as const },
      },
      {
        pattern: /application\/vnd.+(excel|sheet).*/,
        props: { name: 'file-excel' as const },
      },
      {
        pattern: /application\/pdf/,
        props: { source: pdfIcon },
      },
    ].find(({ pattern }) => pattern.test(type))?.props ?? {
      name: 'document',
    }
  );
};

export const FileType = ({
  size,
  value,
  hideIcon,
  loading,
}: {
  size?: PIconProps['size'];
  value: string;
  hideIcon?: boolean;
  loading?: boolean;
}) => {
  const extension =
    allowedFileTypes.find(({ mimeType }) => mimeType === value)?.extension ??
    value.split('/').at(-1);

  if (loading) {
    return <div>{hideIcon ? '...' : <PSpinner />}</div>;
  }

  if (hideIcon) {
    return <>{extension}</>;
  }

  return (
    <div>
      <PIcon
        {...mapTypeToIconProps(value)}
        size={size}
        aria-label={extension}
      />
    </div>
  );
};
